import * as helpers from '../helpers';

/**
 * Find a size record by width, length (depth), and height.
 *
 * Returns the original size structure with only the matched data item.
 *
 * @param sizes - List of size configurations.
 * @param width - Building width.
 * @param length - Building length (depth).
 * @param height - Building height.
 * @returns Matched size object with a single data item, or null if not found.
 */
export function findSizeRecord(
	sizes: any[],
	width: number | string,
	length: number | string,
	height: number | string,
): any {
	if (!Array.isArray(sizes)) {
		return null;
	}

	const size = sizes.find(
		(item) => String(item.width) === String(width) && String(item.depth) === String(length),
	);

	if (!size || !Array.isArray(size.data)) {
		return null;
	}

	const data = size.data.find((item: any) => String(item.height) === String(height));

	if (!data) {
		return null;
	}

	return {
		...size,
		data: [data],
	};
}

/**
 * Returns the current size configuration based on the active building dimensions.
 *
 * @param sizes - List of available size configurations.
 * @returns Matched size configuration or null if not found.
 */
export function getCurrentSizeRecord(sizes: any[]): any {
	return findSizeRecord(
		sizes,
		helpers.getBaseWidth(),
		helpers.getBaseDepth(),
		helpers.getBaseHeight(),
	);
}

/**
 * Returns the wainscoting catalog entry matching the user's current selection.
 *
 * The selected option's id is read from the checked `.ssb_wainscoting` radio's
 * `data-key` attribute, which mirrors the catalog item's `id` field.
 *
 * @param wainscotingList - Full wainscoting catalog for the model.
 * @returns Matched wainscoting entry, or null if none is selected.
 */
export function getCurrentWainscotingRecord(wainscotingList: any[]): any {
	if (!Array.isArray(wainscotingList)) {
		return null;
	}

	const selectedKey = jQuery('.ssb_wainscoting:checked').attr('data-key');
	if (!selectedKey) {
		return null;
	}

	return wainscotingList.find((item) => String(item?.id) === String(selectedKey)) || null;
}
